import { forwardRef, type Ref, type SVGProps } from "react";

function SvgChevronLeft(props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) {
  return (
    <svg ref={ref} xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16" {...props}>
      <path
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M10 13.333 6.08 9.414a2 2 0 0 1 0-2.828L10 2.666"
      />
    </svg>
  );
}
const ForwardRef = forwardRef(SvgChevronLeft);
export default ForwardRef;
